import {HeaderActions, HeaderFilterContainer, HeaderViewContainer} from "./HeaderView.styled";
import {CreateButton, Filters} from "./components";

export const HeaderView = ({ users }) => {
  return (
    <HeaderViewContainer data-testid="header-view-container">
      <HeaderFilterContainer data-testid="header-filter-container">
        <Filters users={users} />
      </HeaderFilterContainer>
      <HeaderActions data-testid="header-actions">
        <CreateButton />
      </HeaderActions>
    </HeaderViewContainer>
  );
}
